import { createFileRoute } from '@tanstack/react-router';

import { Screens } from '~/constants/config/permissions';
import { ContentLayout } from '~/features/content/components/content-layout';
import { requirePermission } from '~/utils/guards';

/**
 * Content section — AI content generation over the product catalog, backed by
 * `agentic-content-generation-service`.
 *
 * Gated on the `content_generation` screen, which identity-service seeds and
 * which is what puts the entry in the sidebar. The guard and the nav have to
 * read the SAME source: a hardcoded super-admin check here against an
 * API-listed nav entry is the desync that shows somebody a link and then
 * bounces them off it.
 *
 * The service itself carries no RBAC beyond "authenticated user of this
 * tenant", and several surfaces here are operator tools (configuration
 * publishes, workflow reset/terminate), so the screen's own role assignment is
 * the only thing standing in front of them.
 *
 * The component mounts `ContentLayout` — a horizontal tab bar like Integrations,
 * pinned above the scrolling page.
 */
export const Route = createFileRoute('/_authenticated/_tenant/content')({
  beforeLoad: requirePermission(Screens.CONTENT_GENERATION),
  component: ContentLayout,
});
